import { useState, useEffect } from "react";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) setShowBanner(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div style={{ position: "fixed", bottom: 0, width: "100%", background: "#000", color: "#fff", padding: "10px", textAlign: "center", zIndex: 1000, fontSize: "14px" }}>
      <span className="cookie-text">We use cookies to enhance your browsing experience, personalize content, and analyze our traffic. By clicking 'Accept', you consent to our use of cookies. You can manage your preferences or decline non-essential cookies at any time.</span>
      <div style={{ marginTop: "10px" }}>
      <button onClick={handleAccept} style={{ marginLeft: "10px", border: "none", borderRadius: "20px", padding: "5px 15px" }}>Accept</button>
      <button onClick={handleDecline} style={{ marginLeft: "10px", border: "none", borderRadius: "20px", padding: "5px 15px" }}>Decline</button>
    </div>
    </div>
  );
};

export default CookieBanner;